module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Stripe":"Stripe","Public Key":"Veröffentlichbarer Schlüssel","Secret Key":"Geheimschlüssel","Webhook Secret":"Webhook Secret"}}')
  delete Component.options._Ctor
}
